// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YkVwV","rootNoMargin":"styles_rootNoMargin__2aGxl"};